<template>
  <div>
    <div class="header">
      <div class="contents">
        <div class="header-left">
          <span class="setname">欢迎来到MOVIBOT！</span>
          <span class="username" v-if="isLogin" @click="toUser()">{{
            UserPhone ? UserPhone : UserMail
          }}</span>
          <span class="useredit" v-if="isLogin" @click="tuichu()"
            >退出登录</span
          >
          <span class="useredit" v-if="!isLogin" @click="toLogin()"
            >登录/注册</span
          >
        </div>
        <div class="header-right">
          <div class="right-item">
            <el-dropdown placement="bottom">
              <div class="el-dropdown-link">
                <img
                  class="link-icon-left"
                  src="../../assets/images/zhinanzhen.png"
                  alt=""
                />
                <span class="link-text">帮助中心</span>
                <img
                  class="link-icon-right"
                  src="../../assets/images/i-01.png"
                  alt=""
                />
              </div>

              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <router-link
                      :to="{
                        name: 'helpfqa',
                        params: {
                          sindex: '5'
                        }
                      }"
                      custom
                      v-slot="{ navigate }"
                    >
                      <span class="help-span" @click="navigate" role="link"
                        >功能介绍</span
                      >
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link
                      :to="{
                        name: 'helpfqa',
                        params: {
                          sindex: '1'
                        }
                      }"
                      custom
                      v-slot="{ navigate }"
                    >
                      <span class="help-span" @click="navigate" role="link"
                        >账户设置</span
                      >
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link
                      :to="{
                        name: 'helpfqa',
                        params: {
                          sindex: '2'
                        }
                      }"
                      custom
                      v-slot="{ navigate }"
                    >
                      <span class="help-span" @click="navigate" role="link"
                        >在线采购</span
                      >
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link
                      :to="{
                        name: 'helpfqa',
                        params: {
                          sindex: '3'
                        }
                      }"
                      custom
                      v-slot="{ navigate }"
                    >
                      <span class="help-span" @click="navigate" role="link"
                        >产品服务</span
                      >
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <router-link
                      :to="{
                        name: 'helpfqa',
                        params: {
                          sindex: '4'
                        }
                      }"
                      custom
                      v-slot="{ navigate }"
                    >
                      <span class="help-span" @click="navigate" role="link"
                        >供应商合作</span
                      >
                    </router-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="right-item">
            <el-dropdown placement="bottom">
              <div class="el-dropdown-link">
                <img
                  class="link-icon-left"
                  src="../../assets/images/phone-icon.png"
                  alt=""
                />
                <span class="link-text">小程序访问</span>
                <img
                  class="link-icon-right"
                  src="../../assets/images/i-01.png"
                  alt=""
                />
              </div>

              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <img
                      src="../../assets/images/movibotcode.png"
                      alt=""
                      style="height: 125px; width:100px"
                    />
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="contents htmltop">
      <div class="titleleft">
        <router-link :to="{ name: 'index' }"
          ><img src="@/assets/common/images/logo.png"
        /></router-link>
      </div>
      <div class="titleright">
        <div class="con">
          <input
            type="text"
            v-on:keyup.enter="doSomething"
            @focus="focusInput('searchinfos')"
            @blur="blurInput('searchinfos')"
            v-model.trim="searchinfos"
            class="inp"
            placeholder="机器人"
          />
          <button class="btn" @click="doSomething">
            <img src="@/assets/common/images/search.png" />
          </button>
          <div
            class="con-list"
            v-show="searchlistshow && searchlist.length > 0"
          >
            <ul>
              <li
                v-if="searchlist && searchlist.length > 0"
                v-for="(item, index) in searchlist.slice(0, 8)"
                :key="index"
              >
                <!-- <p>{{item}}</p>  -->
                <div class="con-list-left" @mousedown="setsearchinfos(item)">
                  {{ item }}
                </div>
                <div class="con-list-right">
                  <i
                    class="icon iconfont icon-quxiao"
                    @mousedown="deletesearch(index)"
                  ></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="userinfo" v-if="isLogin" @click="tuichu()">
          <img src="@/assets/common/images/login.png" />
          <div>退出登录</div>
        </div>
        <div class="userinfo" v-if="!isLogin" @click="toLogin()">
          <img src="@/assets/common/images/login.png" />
          <div>登录/注册</div>
        </div>
        <div class="userinfo" v-else @click="toUser()">
          <img src="@/assets/common/images/me.png" />
          <div>用户中心</div>
        </div>
        <div
          class="userinfo"
          @click="checklanguage()"
          title="其他语言网站正在建设中"
        >
          <img src="@/assets/common/images/language.png" />
          <div>语言</div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      searchinfos: "",
      url: "",
      searchlistshow: false,
      isLogin: false,
      searchlist: []
    };
  },
  watch: {
    UserName(val, oldval) {
      if (val != "") {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
    },
    Keywords(val) {
      this.searchinfos = val;
    }
  },

  mounted() {
    this.getUserCache();
    this.saveSearch(false);
    this.searchinfos = this.Keywords;
  },
  computed: {
    ...mapGetters([
      "UserName",
      "UserPhone",
      "UserMail",
      "Keywords",
      "keywordtime"
    ])
  },

  methods: {
    ...mapActions(["saveUser", "saveKeyword", "saveKeywordTime", "LoginOut"]),

    setsearchinfos(val) {
      this.searchinfos = val;
    },
    checklanguage() {
      this.$FUnitls.showInfo("其他语言网站正在建设中", "info");
    },
    deletesearch(index) {
      this.searchlist.splice(index, 1);
      localStorage.setItem("searchlist", JSON.stringify(this.searchlist));
    },
    tuichu() {
      MessageBox.confirm("确认退出？")
        .then(_ => {
          //退出登录
          this.$cookies.remove("userinfo");
          this.LoginOut();
          this.$router.push({ name: "login" });
          done();
        })
        .catch(_ => {
          //console.log("b");
        });
    },
    //读取缓存数据
    getUserCache() {
      if (
        this.UserName == "" &&
        !(
          localStorage.getItem("currentUser_name") == "" ||
          localStorage.getItem("currentUser_name") == null
        )
      ) {
        this.saveUser();
      }
    },
    saveSearch(type) {
      //保存搜索条件
      var searchlist = [];
      searchlist = JSON.parse(localStorage.getItem("searchlist"));
      if (!searchlist) {
        searchlist = [];
      }
      if (type && this.searchinfos != "") {
        if (!searchlist) {
          searchlist = [];
        }
        searchlist.unshift(this.searchinfos);
        //去重
        searchlist = [...new Set(searchlist)];
        localStorage.setItem("searchlist", JSON.stringify(searchlist));
      }
      this.searchlist = searchlist;
    },
    doSomething: function() {
      if (this.searchinfos == "") {
        // this.$FUnitls.showInfo("关键词不能为空",'error')
        // return false;
        this.searchinfos = "机器人";
      }

      if (this.searchinfos == this.Keywords) {
        this.saveKeywordTime();
      }

      //保存搜索条件
      this.saveSearch(true);

      //console.log("sksksksksksksks")

      this.saveKeyword(this.searchinfos);
      this.$router
        .push({
          name: "search",
          params: {
            searchinfo: this.searchinfos
          }
        })
        .catch(err => {
          //console.log(this.$route.name)
        });
      //}
    },
    // setData(searchinfos,url){
    //     this.searchinfos = searchinfos;
    //     this.url = url;
    // },
    focusInput() {
      this.searchlistshow = true;
    },
    blurInput() {
      this.searchlistshow = false; //失去焦点清空
    },

    /**
     * 登陆注册
     */
    toLogin() {
      this.$router.push({ name: "login" });
    },
    /**
     * 个人中心
     */
    toUser() {
      this.$router.push({ name: "userindex" });
    }
  }
};
</script>

<style scoped>
/* :deep(.el-dropdown) {
  &:hover {
    color: #2655ae;
  }
} */
.header {
  background: #eee;
  height: 40px;
  line-height: 40px;
}
.header .contents {
  color: #666;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}
/* .help-span:hover {
  color: red;
} */
.header .contents .header-right .right-item {
  display: inline-block;
  margin-left: 50px;
  cursor: pointer;
}
.header .contents .header-right .right-item .el-dropdown-link {
  display: inline-block;
  display: flex;
  align-items: center;
}
.header .contents .header-right .right-item .el-dropdown-link .link-text {
  margin-left: 6px;
  margin-right: 6px;
  font-size: 12px;
}
.header .contents .setname {
  color: #888;
}
.header .contents .username {
  padding-left: 10px;
  cursor: pointer;
}
.header .contents .useredit {
  padding-left: 10px;
  cursor: pointer;
}
.titleleft {
  float: left;
  margin-top: 12px;
  margin-left: 5px;
}
.titleright {
  float: right;
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 28px;
  /* padding-right: 45px; */
}

.titleright .con {
  position: relative;
  height: 42px;
  border: 2px solid #fbb113;
  margin-bottom: 2px;
  width: 600px;
  margin-right: 26px;
  border-radius: 25px;
}
.titleright .con .con-list {
  position: absolute;
  top: 44px;
  left: -2px;
  width: 388px;
  background: #ffffff;
  border: 0.5px solid #dbdbdb;
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 9999;
}
.titleright .con .con-list .con-list-left {
  width: 76%;
  float: left;
  padding-left: 4%;
}
.titleright .con .con-list .con-list-right {
  width: 20%;
  float: left;
}

.titleright .con .con-list ul li .icon {
  display: none;
}
.titleright .con .con-list ul li:hover .icon {
  display: inline-block;
  float: right;
  margin-right: 10px;
  font-size: 12px;
  color: #fff;
}
.titleright .con .con-list ul li {
  font-size: 14px;
  color: #707070;
  line-height: 25px;

  cursor: pointer;
}
.titleright .con .con-list ul li:hover .con-list-left,
.titleright .con .con-list ul li:hover .con-list-right {
  color: #fff;
  background-color: #2655ae;
}
.titleright .con .inp {
  width: 490px;
  display: block;
  height: 42px;
  border: 0;
  font-size: 16px;
  margin: 0 110px 0 20px;
  border: 0px;
  outline: none;
}
.titleright .con .btn {
  position: absolute;
  top: -2px;
  right: -2px;
  height: 46px;
  border: 0;
  cursor: pointer;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  width: 66px;
  background: url("/static/icon/search.png") center no-repeat #fbb113;
}
.titleright .con .btn img {
  width: 20px;
}
.titleright .userinfo {
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  text-align: center;
  font-size: 12px;
  align-items: center;
  cursor: pointer;
}
.titleright .userinfo div {
  width: 55px;
  margin-top: 7px;
  color: #999999;
}
.titleright .userinfo img {
  width: 33px;
}
.htmltop {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HtmlTop.vue